export const publicIdInformationDetailKey = {
  all: ['publicIdInformationDetail'] as const,
  detail: (personId: string) => [...publicIdInformationDetailKey.all, personId] as const
} as const;